<!--

 -->

<template>
  <div v-if="!loading">
    <oxd-divider
      v-if="showDivider && selected > 0"
      class="gsl-hrm-horizontal-margin"
    />
    <div
      v-if="selected > 0"
      class="gsl-hrm-horizontal-padding vertical-padding header-row"
    >
      <div v-if="selected > 0">
        <oxd-text tag="span" class="record-text">
          {{ $t('general.n_records_selected', {count: selected}) }}
        </oxd-text>
        <oxd-button
          :label="$t('general.delete_selected')"
          icon-name="trash-fill"
          display-type="label-danger"
          class="gsl-hrm-horizontal-margin"
          @click="$emit('delete', $event)"
        />
      </div>
      <!-- <oxd-text v-else tag="span" class="record-text">
        {{ $t('general.n_records_found', {count: total}) }}
      </oxd-text> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableHeader',

  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    showDivider: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  emits: ['delete'],
};
</script>

<style scoped>
.oxd-divider {
  margin-top: 0;
  margin-bottom: 0;
}
.vertical-padding {
  padding-top: 10px;
  padding-bottom: 10px;
}
.record-text {
  font-size: 0.85rem;
  font-weight: 700;
}

.header-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
